const resources = {
    linkLead: 'Hautement évalué par les clients pour :'
};

export default function getResource(label) {
    return resources[label];
}

